import script from "./AboutRAAIPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutRAAIPage.vue?vue&type=script&setup=true&lang=js"

import "./AboutRAAIPage.vue?vue&type=style&index=0&id=587ee61f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587ee61f"]])

export default __exports__